import { Button, Flex, MediaBox } from "@jewlr/storybook/core"
import { useContext } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { HeaderMenuContext } from "areas/header/portal"
import { NavItem } from "areas/header/portal/menu/desktop/components"

import CountrySelector from "./country-selector"

const Container = styled(Flex).attrs({
  alignItems: "center",
  containWide: true,
  forwardedAs: "nav",
  px: 4,
})`
  align-items: center;
  display: flex;
  height: var(--micro-banner-height);
  justify-content: flex-end;
`

const NavBarLinks = styled.ul`
  align-items: center;
  display: flex;
  margin: 0;
  padding: 0;
`

const NavButton = styled(Button).attrs((props) => ({
  color: "white",
  fontSize: "14px",
  fontWeight: "500",
  letterSpacing: "0.5px",
  mr: 4,
  textTransform: "capitalize",
  variant: "text",
  ...props,
}))`
  &:focus-visible {
    outline: 2px solid ${(props) => props.theme.colors.secondary};
  }
`

const MicroBanner = () => {
  const { menu } = useContext(HeaderMenuContext)
  const navBarLinks = menu && menu.navbar_links

  return (
    <MediaBox bg="primary" greaterThanOrEqual="desktop">
      <Container aria-label="Site Navigation" id="nav-bar">
        {navBarLinks?.length && (
          <NavBarLinks role="menubar">
            {navBarLinks.map((link, i) => (
              <NavItem key={`navbar-item-${i}`} role="none">
                <NavButton
                  data-lc="navbar"
                  role="menuitem"
                  {...(link.external
                    ? {
                        forwardedAs: "a",
                        href: link.url,
                        target: "_blank",
                      }
                    : {
                        forwardedAs: Link,
                        to: link.url,
                      })}
                  {...link.style}
                >
                  {link.name}
                </NavButton>
              </NavItem>
            ))}
          </NavBarLinks>
        )}
        <CountrySelector />
      </Container>
    </MediaBox>
  )
}

export default MicroBanner
